import { useMutation, useQuery } from '@tanstack/vue-query';

import { fetchSpecialDeals, saveSpecialDeal, upsertAndProcessEstatesToSpecialDeal } from '@/api/special-deal.api';
import { withLoading } from '@/shared';
import type { ISaveSpecialDealParams, ISpecialDeal } from '@condo/domain';

export const useSpecialDeal = (salesPackageId: number, shouldFetch = true) => {
    const query = useQuery(['special-deals', salesPackageId], async (): Promise<ISpecialDeal[]> => withLoading(async () => fetchSpecialDeals(salesPackageId)), {
        initialData: [],
        enabled: shouldFetch,
    });

    const { mutateAsync: saveSpecialDealMutation } = useMutation(async (specialDeal: ISaveSpecialDealParams) => saveSpecialDeal(specialDeal));
    const { mutateAsync: upsertAndProcessEstatesToSpecialDealMutation } = useMutation(
        async (params: { specialDealId: number; upsertedEstateIds?: number[]; deletedEstateIds?: number[] }) => upsertAndProcessEstatesToSpecialDeal(params),
    );

    return {
        ...query,
        save: saveSpecialDealMutation,
        upsertEstates: upsertAndProcessEstatesToSpecialDealMutation,
    };
};
